const React = require('react');
const PropTypes = require('prop-types');
const arrowIcon = require('assets/icons/icon-arrow.svg');

const classNames = require('classnames');

import { FormattedText, formatText } from 'core/i18n';
const { getConfig } = require('./helper/residentContainerHelper');

const LIMIT_COUNTRIES = 3;

class ResidentContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    buildOptions(countries) {
        const optionsLinks = countries.map((country, index) => {
            return (
                <li key={index.toString()}>
                    <a href={country.url} className="resident-restriction__country-link">
                        {formatText(country.label)}
                        <img src={arrowIcon} alt="arrow icon" />
                    </a>
                </li>
            );
        });

        return optionsLinks;
    }

    buildCountriesList() {
        const countries = getConfig();
        const arrayCountries = Array(Math.ceil(countries.length / LIMIT_COUNTRIES))
            .join('.')
            .split('.');

        const countriesOptions = arrayCountries.map((c, index) => {
            const contributionClass = classNames('resident-restriction__countries-list', {
                '-no-border': index + 1 === arrayCountries.length,
            });
            return (
                <div className="col-xs-12 col-md-4" key={index.toString()}>
                    <div className="resident-restriction__countries-list-container">
                        <ul className={contributionClass}>
                            {this.buildOptions(
                                countries.slice(index * LIMIT_COUNTRIES, index * LIMIT_COUNTRIES + LIMIT_COUNTRIES)
                            )}
                        </ul>
                    </div>
                </div>
            );
        });

        return countriesOptions;
    }

    render() {
        return (
            <div
                ref="countryDiv"
                className={this.props.hiddenResidentContainer ? 'hidden' : 'resident-restriction'}
                id={this.props.id}
            >
                <div className="prospects-gutter prospects-separator">
                    <div className="row">
                        <div className="col-xs-12">
                            <i className="icons icons--icon-non-resident"></i>
                            <h5 className="font-heading5 resident-restriction__title">
                                <FormattedText value="initial-thankYouInterested" />
                            </h5>
                            <hr className="dash" />
                            <p className="font-paragraph2 resident-restriction__description">
                                <FormattedText value="initial-weRegretInconvenience" />{' '}
                                {/*otherCountriesDescription add when all countries complete*/}
                            </p>
                            <div className="row">
                                {/*this.buildCountriesList() -> add when all countries complete*/}
                            </div>
                            <div className="resident-restriction__phone-contact">
                                <i className="icons icons--icon-phone-blue"></i>
                                <p className="font-paragraph2 age-restriction__call-center">
                                    <FormattedText value="initial-contactMessageNumber" />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form__footer form__footer-inner">
                    <div className="text-right">
                        <button
                            type="button"
                            className="form__button form__button-secondary"
                            onClick={this.props.handleOnClick}
                        >
                            <FormattedText value="button-understood" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

ResidentContainer.propTypes = {
    hiddenResidentContainer: PropTypes.bool,
    handleOnClick: PropTypes.func,
};

module.exports = ResidentContainer;
